// Keep an explicitly selected sample through the existing sign-in redirect.
// This is a temporary creative draft, separate from durable submission keys.
const key = 'adfini-example-brief';
export function rememberExampleBrief(brief) {
  try { sessionStorage.setItem(key, JSON.stringify({ brief, expires: Date.now() + 30 * 60 * 1000 })); } catch { /* Draft storage is optional. */ }
}
export function readExampleBrief() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    return saved?.expires > Date.now() && typeof saved.brief === 'string' ? saved.brief.slice(0, 8000) : '';
  } catch { return ''; }
}
export function clearExampleBrief() {
  try { sessionStorage.removeItem(key); } catch { /* Draft storage is optional. */ }
}
